// Friendly empty/placeholder state for lists and tables.

import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

const EmptyState = ({ icon: Icon = InboxOutlinedIcon, title = "Nothing here yet", description, action }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      py: 6,
      px: 3,
      color: "text.secondary",
    }}
  >
    <Icon sx={{ fontSize: 56, opacity: 0.5, mb: 1.5 }} />
    <Typography variant="h6" sx={{ fontWeight: 600, color: "text.primary" }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" sx={{ mt: 0.5, maxWidth: 360 }}>
        {description}
      </Typography>
    )}
    {action && <Box sx={{ mt: 2 }}>{action}</Box>}
  </Box>
);

export default EmptyState;
